export type CategoriaDoc =
  | "legal"
  | "financiero"
  | "tecnico"
  | "actas"
  | "contratos"
  | "permisos";

export type DocumentoTipo = "pdf" | "xlsx" | "docx" | "jpg" | "zip";

export interface DocumentoAPR {
  id: string;
  codigo: string;
  nombre: string;
  categoria: CategoriaDoc;
  descripcion: string;
  fechaSubida: string;
  fechaVencimiento?: string;
  tamaño: string;
  tipo: DocumentoTipo;
  subidoPor: string;
  version: string;
  estado: "vigente" | "vencido" | "revision";
  etiquetas: string[];
  url?: string;
}

export const categoriasConfig: Record<CategoriaDoc, { label: string; icon: string; color: string; bg: string }> = {
  legal: { label: "Legal y Estatutario", icon: "ri-scales-line", color: "text-indigo-600", bg: "bg-indigo-50" },
  financiero: { label: "Financiero / Contable", icon: "ri-money-dollar-circle-line", color: "text-emerald-600", bg: "bg-emerald-50" },
  tecnico: { label: "Técnico / Infraestructura", icon: "ri-tools-line", color: "text-teal-600", bg: "bg-teal-50" },
  actas: { label: "Actas y Reuniones", icon: "ri-file-text-line", color: "text-amber-600", bg: "bg-amber-50" },
  contratos: { label: "Contratos y Convenios", icon: "ri-file-paper-2-line", color: "text-rose-600", bg: "bg-rose-50" },
  permisos: { label: "Permisos y Resoluciones", icon: "ri-government-line", color: "text-violet-600", bg: "bg-violet-50" },
};
